// assets/wu-card.js
;(async function(){
  // Prevent duplicate initialization
  if (window.wuCardInitialized) {
    console.log("⚠️ wu-card.js already initialized, skipping");
    return;
  }
  window.wuCardInitialized = true;
  
  console.log("🔧 wu-card.js loaded");

  function init(){
    console.log("📦 init()");
    const wuName  = sessionStorage.getItem("wuName");
    const userLoc = sessionStorage.getItem("location");

    const noSessionEl = document.getElementById("no-session");
    if (!wuName || !userLoc) {
      if (noSessionEl) noSessionEl.style.display = "block";
      document.querySelectorAll(".wu-step").forEach(el => el.style.display = "none");
      return;
    }
    const safeWuName  = wuName;
    const safeUserLoc = userLoc;

    // Steps
    const selectionStep     = document.querySelector(".wu-step-selection");
    const photoSourceStep   = document.querySelector(".wu-step-photo-source");
    const adjustmentStep    = document.querySelector(".wu-step-adjustment");
    const customizationStep = document.querySelector(".wu-step-customization");
    const finalStep         = document.querySelector(".wu-step-final");

    // Controls
    const artworkControl        = document.getElementById("opt-artwork");
    const artworkHeadingLabel   = document.getElementById("artwork-heading-label");
    const artworkSelectionSlot  = document.getElementById("artwork-selection-slot");
    const artworkCustomizeOptions = document.getElementById("artwork-customization-options");
    const artworkDisclosureToggle = document.getElementById("artwork-disclosure-toggle");
    const artworkPreview        = document.getElementById("artwork-preview");
    const staticArtworkPreview  = artworkPreview?.querySelector(".intro-graphic__static");
    const selectedArtworkPreview = document.getElementById("selected-artwork-preview");
    const continueToPhotoBtn    = document.getElementById("continue-to-photo");
    const backToArtworkBtn      = document.getElementById("back-to-artwork");
    const backToPhotoBtn        = document.getElementById("back-to-photo");
    const uploadInput           = document.getElementById("upload-photo");
    const uploadBtn             = document.getElementById("upload-photo-btn");
    const continueToCustomizeBtn = document.getElementById("continue-to-customize");
    const takeBtn               = document.getElementById("take-photo");
    const cameraWrap            = document.getElementById("camera-capture");
    const captureBtn            = document.getElementById("capture-photo");
    const videoEl               = document.getElementById("camera-video");
    const photoStatus           = document.getElementById("wu-photo-status");
    const photoStatusMessage    = document.getElementById("wu-photo-status-message");
    const retryProcessingBtn    = document.getElementById("retry-photo-processing");
    const mediaPipeConfigEl     = document.getElementById("wu-card-mediapipe-assets");

    // Canvases
    const canvas      = document.getElementById("photo-canvas");
    const ctx         = canvas.getContext("2d", { willReadFrequently: true });
    const finalCanvas = document.getElementById("final-canvas");
    const fctx        = finalCanvas.getContext("2d", { willReadFrequently: true });

    const saveButton    = document.getElementById("save-card");
    const shareButton   = document.getElementById("share-card");
    const startOverBtn  = document.getElementById("start-over");
    const completeBtn   = document.getElementById("complete-card");
    const exportStatus  = document.getElementById("wu-card-export-status");
    const app            = document.getElementById("wu-card-app");

    // Sizing
    const CANVAS_W = 450, CANVAS_H = 600;
    canvas.width = CANVAS_W; canvas.height = CANVAS_H;

    // Initial visibility
    canvas.style.display = "none";
    videoEl.style.display = "none";
    captureBtn.style.display = "none";
    if (cameraWrap) cameraWrap.style.display = "none";

    // Assets
    const cardDefinitions = Array.from(document.querySelectorAll("[data-wu-card-collection] [data-wu-card]"))
      .map(cardEl => ({
        key: cardEl.dataset.cardKey,
        title: cardEl.dataset.cardTitle,
        accessibilityLabel: cardEl.dataset.cardAccessibilityLabel || cardEl.dataset.cardTitle,
        selectionImage: cardEl.dataset.cardSelectionImage || cardEl.dataset.cardBackground,
        backgroundImage: cardEl.dataset.cardBackground,
        nameplateImage: cardEl.dataset.cardNameplate,
        editionNumber: cardEl.dataset.cardEdition || "",
      }))
      .filter(card => card.key && card.backgroundImage && card.nameplateImage);
    const cardsByKey = new Map(cardDefinitions.map(card => [card.key, card]));
    const borders = {
      gold:   "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Gold_Border.webp?v=1752591498",
      silver: "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Silver_Border.webp?v=1752591498",
      black:  "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Black_Border.webp?v=1752591498",
    };
    const numberBgUrl    = "https://cdn.shopify.com/s/files/1/0588/2704/7117/files/Card_Number_BG.webp?v=1752591498";
    const storedCardKey = sessionStorage.getItem("selectedCardKey");
    let selectedCardKey = cardsByKey.has(storedCardKey) ? storedCardKey : null;
    if (!selectedCardKey) sessionStorage.removeItem("selectedCardKey");
    let currentBorder = "silver";  // Track current border too

    // Overlay assets
    const bgImg       = new Image();
    const plateImg    = new Image();
    const brdImg      = new Image();
    const numberBgImg = new Image();
    [bgImg, plateImg, brdImg, numberBgImg].forEach(img => img.crossOrigin = "anonymous");

    // 🔒 Face buffer canvas (source of truth)
    let faceBuffer = document.createElement("canvas");
    let faceCtx    = faceBuffer.getContext("2d", { willReadFrequently: true });

    // State
    let hasFace = false;
    let assetsReady = false;
    let needsRender = false;
    let loadToken = 0;         // guards stale image loads
    let uiLocked = false;      // block interactions while loading
    let portraitSegmenter = null;
    let portraitSegmenterPromise = null;
    let portraitProcessingActive = false;
    let portraitGeneration = 0;
    let retrySourceCanvas = null;
    let portraitProcessingDestroyed = false;
    let exportCache = null;
    let exportPromise = null;
    let exportActionActive = false;
    let exportGeneration = 0;
    let previewCardKey = null;
    let previewGeneration = 0;

    const exportFileName = (safeWuName || "Wu-Card")
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-zA-Z0-9\-]/g, '')
      + "-Wu-Card.png";

    // Pan/zoom state with clamps
    let scale = 1, offsetX = 0, offsetY = 0, dragging = false, startX = 0, startY = 0;
    let minScale = 0.2, maxScale = 6;

    function sanitizeTransform(){
      if (!Number.isFinite(scale) || scale <= 0) scale = 1;
      if (!Number.isFinite(offsetX)) offsetX = 0;
      if (!Number.isFinite(offsetY)) offsetY = 0;
      scale = Math.min(maxScale, Math.max(minScale, scale));
      
      // Debug log to track state changes
      if (window.wuCardDebug) {
        console.log("Transform sanitized:", { scale, offsetX, offsetY, minScale, maxScale });
      }
    }

    function scheduleRender(){
      if (needsRender) return;
      needsRender = true;
      requestAnimationFrame(() => {
        needsRender = false;
        renderAll();
      });
    }

    function setExportStatus(message){
      if (exportStatus) exportStatus.textContent = message;
    }

    function setExportControlsDisabled(disabled){
      if (saveButton) saveButton.disabled = disabled;
      if (shareButton) shareButton.disabled = disabled;
    }

    function revokeExportUrl(){
      if (!exportCache?.objectUrl) return;
      URL.revokeObjectURL(exportCache.objectUrl);
      exportCache.objectUrl = "";
    }

    function invalidateExportCache(){
      exportGeneration += 1;
      revokeExportUrl();
      exportCache = null;
      exportPromise = null;
      app?.classList.remove("wu-card-builder--file-share");
      if (shareButton) shareButton.querySelector("span").textContent = "Share";
    }

    function supportsFileShare(output = exportCache){
      if (!navigator.share || !navigator.canShare || !output?.file) return false;
      try {
        return navigator.canShare({ files: [output.file] });
      } catch (error) {
        console.warn("File share capability check failed:", error);
        return false;
      }
    }

    function syncExportActions(){
      const nativeShareAvailable = typeof navigator.share === "function";
      const fileShareAvailable = supportsFileShare();
      if (shareButton) {
        shareButton.hidden = !nativeShareAvailable;
        shareButton.querySelector("span").textContent = fileShareAvailable ? "Share / Save Image" : "Share";
      }
      app?.classList.toggle("wu-card-builder--file-share", fileShareAvailable);
    }

    function canvasToPngBlob(){
      return new Promise((resolve, reject) => {
        finalCanvas.toBlob(blob => {
          if (blob) resolve(blob);
          else reject(new Error("The completed Wu-Card PNG could not be created."));
        }, "image/png");
      });
    }

    async function prepareExport(){
      if (exportCache) return exportCache;
      if (exportPromise) return exportPromise;

      const generation = exportGeneration;
      const pendingExport = (async () => {
        fctx.clearRect(0, 0, finalCanvas.width, finalCanvas.height);
        drawFace(fctx);
        drawOverlay(fctx);

        const blob = await canvasToPngBlob();
        if (generation !== exportGeneration) {
          throw new Error("The Wu-Card changed while the PNG was being prepared.");
        }
        let file = null;
        if (typeof File === "function") {
          try {
            file = new File([blob], exportFileName, { type: "image/png" });
          } catch (error) {
            console.warn("PNG File creation is unavailable:", error);
          }
        }

        exportCache = {
          blob,
          file,
          filename: exportFileName,
          objectUrl: "",
        };
        syncExportActions();
        return exportCache;
      })();
      exportPromise = pendingExport;

      try {
        return await pendingExport;
      } finally {
        if (exportPromise === pendingExport) exportPromise = null;
      }
    }

    async function runExportAction(action){
      if (exportActionActive) return;
      exportActionActive = true;
      setExportControlsDisabled(true);
      try {
        await action();
      } finally {
        exportActionActive = false;
        setExportControlsDisabled(false);
      }
    }

    function downloadExport(output){
      if (!output.objectUrl) output.objectUrl = URL.createObjectURL(output.blob);
      const downloadLink = document.createElement("a");
      downloadLink.href = output.objectUrl;
      downloadLink.download = output.filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      requestAnimationFrame(() => downloadLink.remove());
    }

    function preloadSelectedAssets(brd, cb){
      const card = cardsByKey.get(selectedCardKey);
      if (!card) {
        console.error("Selected card configuration not found:", selectedCardKey);
        return;
      }

      const selectedAssetsAreLoaded = assetsReady
        && bgImg.src === card.backgroundImage
        && plateImg.src === card.nameplateImage
        && brdImg.src === borders[brd]
        && numberBgImg.src === numberBgUrl;
      if (selectedAssetsAreLoaded) {
        console.log("♻️ Assets already loaded for this config, skipping");
        completeBtn.disabled = false;
        cb?.();
        return;
      }
      
      console.log("🔄 Loading assets:", { cardKey: selectedCardKey, brd });
      currentBorder = brd;  // Track the border too
      uiLocked = true;
      assetsReady = false;
      completeBtn.disabled = true;

      const token = ++loadToken;
      let loaded = 0;
      const all = [bgImg, plateImg, brdImg, numberBgImg];
      bgImg.src       = card.backgroundImage;
      plateImg.src    = card.nameplateImage;
      brdImg.src      = borders[brd];
      numberBgImg.src = numberBgUrl;

      const done = () => {
        if (++loaded === all.length) {
          if (token !== loadToken) return; // ignore stale loads
          assetsReady = true;
          uiLocked = false;
          completeBtn.disabled = false;
          console.log("✅ Assets ready");
          cb?.();
        }
      };

      all.forEach(img => {
        if (img.complete && img.naturalWidth) done();
        else {
          img.onload  = done;
          img.onerror = (e) => { console.error("Image failed:", img.src, e); done(); };
        }
      });
    }

    function showStep(activeStep){
      if (artworkPreview && (activeStep === selectionStep || activeStep === photoSourceStep)) {
        activeStep.prepend(artworkPreview);
      }
      document.querySelectorAll(".wu-step").forEach(step => {
        step.style.display = step === activeStep ? "block" : "none";
      });
    }

    function mountArtworkControl(slot, heading){
      if (slot && artworkControl && !slot.contains(artworkControl)) {
        slot.appendChild(artworkControl);
      }
      if (artworkHeadingLabel) artworkHeadingLabel.textContent = heading;
    }

    function setArtworkDisclosureExpanded(expanded){
      if (!artworkDisclosureToggle || !artworkCustomizeOptions) return;
      artworkDisclosureToggle.setAttribute("aria-expanded", String(expanded));
      artworkCustomizeOptions.hidden = !expanded;
    }

    function hasValidSelectedCard(){
      return Boolean(selectedCardKey && cardsByKey.has(selectedCardKey));
    }

    function restoreStaticArtworkPreview(){
      previewGeneration += 1;
      previewCardKey = null;
      artworkPreview?.classList.remove("intro-graphic--selected");
      staticArtworkPreview?.removeAttribute("aria-hidden");
      if (!selectedArtworkPreview) return;
      selectedArtworkPreview.onload = null;
      selectedArtworkPreview.onerror = null;
      selectedArtworkPreview.removeAttribute("src");
      selectedArtworkPreview.alt = "";
      selectedArtworkPreview.setAttribute("aria-hidden", "true");
    }

    function syncArtworkPreview(){
      const card = cardsByKey.get(selectedCardKey);
      if (!card?.selectionImage || !selectedArtworkPreview || !artworkPreview) {
        restoreStaticArtworkPreview();
        return;
      }
      if (previewCardKey === selectedCardKey) return;

      const generation = ++previewGeneration;
      previewCardKey = selectedCardKey;
      artworkPreview.classList.remove("intro-graphic--selected");
      staticArtworkPreview?.removeAttribute("aria-hidden");
      selectedArtworkPreview.setAttribute("aria-hidden", "true");
      selectedArtworkPreview.alt = card.accessibilityLabel || card.title || "Selected Wu-Card artwork";

      selectedArtworkPreview.onload = () => {
        if (generation !== previewGeneration || previewCardKey !== selectedCardKey) return;
        staticArtworkPreview?.setAttribute("aria-hidden", "true");
        selectedArtworkPreview.removeAttribute("aria-hidden");
        requestAnimationFrame(() => {
          if (generation !== previewGeneration || previewCardKey !== selectedCardKey) return;
          artworkPreview.classList.add("intro-graphic--selected");
        });
      };
      selectedArtworkPreview.onerror = () => {
        if (generation !== previewGeneration) return;
        restoreStaticArtworkPreview();
      };
      selectedArtworkPreview.src = card.selectionImage;
    }

    function syncArtworkSelection(){
      document.querySelectorAll("input[name='artwork']").forEach(radio => {
        radio.checked = radio.value === selectedCardKey;
      });
      if (continueToPhotoBtn) continueToPhotoBtn.disabled = !hasValidSelectedCard();
      syncArtworkPreview();
    }

    function setArtworkInputsDisabled(disabled){
      document.querySelectorAll("input[name='artwork']").forEach(radio => {
        radio.disabled = disabled;
      });
    }

    function selectCard(cardKey, shouldRender = false){
      if (!cardsByKey.has(cardKey)) {
        selectedCardKey = null;
        sessionStorage.removeItem("selectedCardKey");
        syncArtworkSelection();
        return false;
      }

      selectedCardKey = cardKey;
      sessionStorage.setItem("selectedCardKey", selectedCardKey);
      syncArtworkSelection();

      if (shouldRender) {
        preloadSelectedAssets(currentBorder, () => renderAll());
      }
      return true;
    }

    mountArtworkControl(artworkSelectionSlot, "ARTWORK");
    syncArtworkSelection();
    showStep(selectionStep);

    artworkDisclosureToggle?.addEventListener("click", () => {
      setArtworkDisclosureExpanded(artworkDisclosureToggle.getAttribute("aria-expanded") !== "true");
    });

    // Helpers: set faceBuffer from a canvas (segmented tmp) - Enhanced with debugging
    function setFaceFromCanvas(sourceCanvas){
      if (!sourceCanvas || !sourceCanvas.width || !sourceCanvas.height) {
        console.warn("❌ Invalid source canvas for setFaceFromCanvas");
        return;
      }
      
      console.log(`📐 Setting face from canvas: ${sourceCanvas.width}x${sourceCanvas.height}`);
      
      faceBuffer.width  = sourceCanvas.width;
      faceBuffer.height = sourceCanvas.height;
      faceCtx.clearRect(0, 0, faceBuffer.width, faceBuffer.height);
      faceCtx.drawImage(sourceCanvas, 0, 0);
      hasFace = true;

      // Fit into card
      const rW = CANVAS_W / faceBuffer.width;
      const rH = CANVAS_H / faceBuffer.height;
      const fit = Math.min(rW, rH);
      
      console.log(`📏 Calculated fit ratio: ${fit} (rW: ${rW}, rH: ${rH})`);
      
      scale   = fit;
      minScale = fit * 0.35;
      maxScale = fit * 5;
      offsetX = (CANVAS_W - faceBuffer.width  * scale) / 2;
      offsetY = (CANVAS_H - faceBuffer.height * scale) / 2;
      
      console.log(`🎯 Transform set - scale: ${scale}, offset: (${offsetX}, ${offsetY})`);
      console.log(`📊 Scale bounds - min: ${minScale}, max: ${maxScale}`);
    }

    // ======= Drawing - Fixed to prevent white canvas =======
    function drawFace(ctxTarget = ctx){
      console.log("🎨 Drawing face...", {
        hasFace,
        assetsReady,
        scale,
        offsetX,
        offsetY,
        faceBufferSize: hasFace ? `${faceBuffer.width}x${faceBuffer.height}` : 'none'
      });

      // Always paint neutral background first
      ctxTarget.save();
      ctxTarget.setTransform(1,0,0,1,0,0);
      ctxTarget.clearRect(0,0,CANVAS_W,CANVAS_H);
      
      // CRITICAL FIX: Use a light gray instead of white when no background is ready
      // This prevents the jarring white flash
      ctxTarget.fillStyle = assetsReady ? "#fff" : "#f0f0f0";
      ctxTarget.fillRect(0,0,CANVAS_W,CANVAS_H);
      ctxTarget.restore();

      // BG if ready - only draw if assets are actually loaded
      if (assetsReady && bgImg.complete && bgImg.naturalWidth) {
        console.log("🖼️ Drawing background image");
        try { 
          ctxTarget.drawImage(bgImg, 0,0, CANVAS_W, CANVAS_H); 
        } catch(e){ 
          console.error("❌ Background draw error:", e);
        }
      } else {
        console.log("⏳ Background not ready yet, showing placeholder");
      }

      // Face - only draw if we have a valid face
      if (hasFace && faceBuffer.width > 0 && faceBuffer.height > 0){
        const fw = faceBuffer.width  * scale;
        const fh = faceBuffer.height * scale;
        
        console.log(`👤 Drawing face: size ${fw}x${fh} at (${offsetX}, ${offsetY})`);
        
        if (Number.isFinite(fw) && Number.isFinite(fh) && fw > 0 && fh > 0 && 
            Number.isFinite(offsetX) && Number.isFinite(offsetY)){
          try { 
            ctxTarget.drawImage(faceBuffer, offsetX, offsetY, fw, fh); 
            console.log("✅ Face drawn successfully");
          } catch(e){ 
            console.error("❌ Face draw error:", e);
          }
        } else {
          console.error("❌ Invalid face dimensions or position:", { fw, fh, offsetX, offsetY });
        }
      } else if (hasFace) {
        console.log("❌ Face buffer has invalid dimensions");
      }
    }

    function drawOverlay(ctxTarget = ctx){
      // CRITICAL FIX: Only draw overlay if assets are ready
      if (!assetsReady) {
        console.log("⏳ Skipping overlay - assets not ready");
        return;
      }

      // Guard against zero/NaN sizes from missing images
      const pW = plateImg.naturalWidth  || CANVAS_W;
      const pH = plateImg.naturalHeight || Math.round(CANVAS_W * 0.25);
      const aspectP = pH / pW;

      // Nameplate
      const pw = CANVAS_W;
      const ph = Math.max(1, pw * aspectP);
      const py = CANVAS_H - ph - 20;
      
      if (plateImg.complete && plateImg.naturalWidth) {
        try { ctxTarget.drawImage(plateImg, 0, py, pw, ph); } catch(e){ console.error("Plate draw error:", e); }
      }

      // Text colors
      const fillCol   = document.querySelector("input[name='name-color']:checked")?.value || "#000";
      const strokeCol = fillCol === "#000" ? "#fff" : "#000";

      // Plate text area
      const textAreaX = 50;
      const textAreaW = pw - (textAreaX * 2);
      const textAreaY = py + (ph * 0.65);
      const textAreaH = ph * 0.35;

      const NAME_TXT = (safeWuName || "").toUpperCase();
      const LOC_TXT  = (safeUserLoc || "").toUpperCase();

      // Start sizes
      let nameFontSize = 28;
      let locFontSize  = 20;

      // Fit name
      ctxTarget.font = `bold ${nameFontSize}px 'Archivo Expanded Black', sans-serif`;
      let nameWidth = ctxTarget.measureText(NAME_TXT).width;
      while (nameWidth > textAreaW && nameFontSize > 12) {
        nameFontSize--;
        ctxTarget.font = `bold ${nameFontSize}px 'Archivo Expanded Black', sans-serif`;
        nameWidth = ctxTarget.measureText(NAME_TXT).width;
      }

      // Fit location
      locFontSize = Math.min(locFontSize, Math.floor(nameFontSize * 0.7));
      ctxTarget.font = `bold ${locFontSize}px 'Archivo Expanded Black', sans-serif`;
      let locWidth = ctxTarget.measureText(LOC_TXT).width;
      while (locWidth > textAreaW && locFontSize > 10) {
        locFontSize--;
        ctxTarget.font = `bold ${locFontSize}px 'Archivo Expanded Black', sans-serif`;
        locWidth = ctxTarget.measureText(LOC_TXT).width;
      }

      // Vertical positions
      const lineGap = 5;
      const totalTextHeight = nameFontSize + lineGap + locFontSize;
      const startY = textAreaY + (textAreaH - totalTextHeight) / 2;

      ctxTarget.save();
      ctxTarget.textAlign = "center";
      ctxTarget.textBaseline = "top";

      // Name
      ctxTarget.font = `bold ${nameFontSize}px 'Archivo Expanded Black', sans-serif`;
      ctxTarget.lineWidth = 2;
      ctxTarget.strokeStyle = strokeCol;
      ctxTarget.fillStyle = fillCol;
      if (Number.isFinite(startY)) {
        ctxTarget.strokeText(NAME_TXT, CANVAS_W/2, startY);
        ctxTarget.fillText(NAME_TXT, CANVAS_W/2, startY);
      }

      // Location
      ctxTarget.font = `bold ${locFontSize}px 'Archivo Expanded Black', sans-serif`;
      ctxTarget.lineWidth = 1.5;
      if (Number.isFinite(startY)) {
        ctxTarget.strokeText(LOC_TXT, CANVAS_W/2, startY + nameFontSize + lineGap);
        ctxTarget.fillText(LOC_TXT, CANVAS_W/2, startY + nameFontSize + lineGap);
      }

      ctxTarget.restore();

      // Border
      if (brdImg.complete && brdImg.naturalWidth) {
        try { ctxTarget.drawImage(brdImg, 0, 0, CANVAS_W, CANVAS_H); } catch(e){ console.error("Border draw error:", e); }
      }

      // Edition badge
      const nbW = 100, nbH = 50, nbY = 60, extra = 10;
      const nbX = CANVAS_W - nbW + extra;
      
      if (numberBgImg.complete && numberBgImg.naturalWidth) {
        try { ctxTarget.drawImage(numberBgImg, nbX, nbY, nbW, nbH); } catch(e){ console.error("Number BG draw error:", e); }
      }

      ctxTarget.save();
      ctxTarget.fillStyle = "#000";
      ctxTarget.font = "bold 16px 'Archivo Expanded Black', sans-serif";
      ctxTarget.textAlign = "left";
      ctxTarget.textBaseline = "middle";
      const editionNumber = cardsByKey.get(selectedCardKey)?.editionNumber || "";
      ctxTarget.fillText(editionNumber, nbX + 40, nbY + nbH/2);
      ctxTarget.restore();
    }

    function renderAll(){
      // CRITICAL FIX: Don't render if we're still loading
      if (uiLocked && !assetsReady) {
        console.log("🔒 Skipping render - assets still loading");
        return;
      }
      
      // Additional safety check - don't lose face data
      if (!hasFace && faceBuffer.width > 0) {
        console.warn("⚠️ Face flag was false but buffer exists - recovering");
        hasFace = true;
      }
      
      try {
        invalidateExportCache();
        sanitizeTransform();
        drawFace(ctx);
        drawOverlay(ctx);
      } catch (e){
        console.error("renderAll error:", e);
      }
    }

    const MAX_PORTRAIT_EDGE = 1280;
    const PORTRAIT_FAILURE_MESSAGE = "We couldn’t remove the background. Try again or choose another photo.";

    function readMediaPipeConfig(){
      if (!mediaPipeConfigEl) throw new Error("MediaPipe asset configuration is missing.");

      const config = JSON.parse(mediaPipeConfigEl.textContent);
      const requiredUrls = [
        "moduleUrl",
        "simdLoaderUrl",
        "simdBinaryUrl",
        "noSimdLoaderUrl",
        "noSimdBinaryUrl",
        "modelUrl",
      ];
      requiredUrls.forEach(key => {
        if (!config[key]) throw new Error(`MediaPipe asset URL is missing: ${key}`);
        config[key] = new URL(config[key], document.baseURI).href;
      });
      return config;
    }

    async function loadPortraitSegmenter(){
      if (portraitSegmenter) return portraitSegmenter;
      if (portraitSegmenterPromise) return portraitSegmenterPromise;

      portraitSegmenterPromise = (async () => {
        const config = readMediaPipeConfig();
        const { FilesetResolver, ImageSegmenter } = await import(config.moduleUrl);
        const supportsSimd = await FilesetResolver.isSimdSupported(false);
        const fileset = supportsSimd
          ? {
              wasmLoaderPath: config.simdLoaderUrl,
              wasmBinaryPath: config.simdBinaryUrl,
            }
          : {
              wasmLoaderPath: config.noSimdLoaderUrl,
              wasmBinaryPath: config.noSimdBinaryUrl,
            };
        const segmenter = await ImageSegmenter.createFromOptions(fileset, {
          baseOptions: { modelAssetPath: config.modelUrl },
          runningMode: "IMAGE",
          outputCategoryMask: false,
          outputConfidenceMasks: true,
        });

        if (portraitProcessingDestroyed) {
          segmenter.close();
          throw new Error("Wu Card Builder was removed before MediaPipe finished loading.");
        }

        portraitSegmenter = segmenter;
        console.log("✅ MediaPipe portrait model ready");
        return portraitSegmenter;
      })().catch(error => {
        portraitSegmenterPromise = null;
        throw error;
      });

      return portraitSegmenterPromise;
    }

    function setPhotoProcessingState(state){
      const messages = {
        preparing: "Preparing photo tools…",
        processing: "Processing your photo…",
        error: PORTRAIT_FAILURE_MESSAGE,
      };
      const isBusy = state === "preparing" || state === "processing";
      const message = messages[state] || "";

      if (photoStatus) {
        photoStatus.hidden = !message;
        photoStatus.dataset.state = state;
      }
      if (photoStatusMessage) photoStatusMessage.textContent = message;
      if (retryProcessingBtn) retryProcessingBtn.hidden = state !== "error" || !retrySourceCanvas;
      if (photoSourceStep) {
        if (isBusy) photoSourceStep.setAttribute("aria-busy", "true");
        else photoSourceStep.removeAttribute("aria-busy");
      }

      [uploadBtn, takeBtn, captureBtn, backToArtworkBtn].forEach(control => {
        if (control) control.disabled = isBusy;
      });
    }

    function clearTemporaryCanvas(temporaryCanvas){
      if (!temporaryCanvas) return;
      temporaryCanvas.width = 0;
      temporaryCanvas.height = 0;
    }

    function replaceRetrySource(sourceCanvas){
      if (retrySourceCanvas && retrySourceCanvas !== sourceCanvas) {
        clearTemporaryCanvas(retrySourceCanvas);
      }
      retrySourceCanvas = sourceCanvas;
    }

    function createBoundedPortraitSource(source, mirror = false){
      const sourceWidth = source.videoWidth || source.naturalWidth || source.width;
      const sourceHeight = source.videoHeight || source.naturalHeight || source.height;
      if (!sourceWidth || !sourceHeight) throw new Error("The portrait source has no usable dimensions.");

      const ratio = Math.min(1, MAX_PORTRAIT_EDGE / Math.max(sourceWidth, sourceHeight));
      const width = Math.max(1, Math.round(sourceWidth * ratio));
      const height = Math.max(1, Math.round(sourceHeight * ratio));
      const boundedCanvas = document.createElement("canvas");
      boundedCanvas.width = width;
      boundedCanvas.height = height;
      const boundedContext = boundedCanvas.getContext("2d", { willReadFrequently: true });
      boundedContext.imageSmoothingEnabled = true;
      boundedContext.imageSmoothingQuality = "high";
      if (mirror) {
        boundedContext.translate(width, 0);
        boundedContext.scale(-1, 1);
      }
      boundedContext.drawImage(source, 0, 0, width, height);
      return boundedCanvas;
    }

    function applyMediaPipeAlpha(sourceCanvas, backgroundMask){
      const maskValues = backgroundMask.getAsFloat32Array();
      const maskCanvas = document.createElement("canvas");
      const resizedMaskCanvas = document.createElement("canvas");
      const outputCanvas = document.createElement("canvas");

      try {
        maskCanvas.width = backgroundMask.width;
        maskCanvas.height = backgroundMask.height;
        const maskContext = maskCanvas.getContext("2d");
        const maskPixels = maskContext.createImageData(backgroundMask.width, backgroundMask.height);
        for (let index = 0; index < maskValues.length; index += 1) {
          const value = Math.round(Math.max(0, Math.min(1, maskValues[index])) * 255);
          const pixel = index * 4;
          maskPixels.data[pixel] = value;
          maskPixels.data[pixel + 1] = value;
          maskPixels.data[pixel + 2] = value;
          maskPixels.data[pixel + 3] = 255;
        }
        maskContext.putImageData(maskPixels, 0, 0);

        resizedMaskCanvas.width = sourceCanvas.width;
        resizedMaskCanvas.height = sourceCanvas.height;
        const resizedMaskContext = resizedMaskCanvas.getContext("2d", { willReadFrequently: true });
        resizedMaskContext.imageSmoothingEnabled = true;
        resizedMaskContext.imageSmoothingQuality = "high";
        resizedMaskContext.drawImage(maskCanvas, 0, 0, sourceCanvas.width, sourceCanvas.height);
        const resizedMaskPixels = resizedMaskContext.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height).data;

        outputCanvas.width = sourceCanvas.width;
        outputCanvas.height = sourceCanvas.height;
        const outputContext = outputCanvas.getContext("2d", { willReadFrequently: true });
        outputContext.drawImage(sourceCanvas, 0, 0);
        const outputPixels = outputContext.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
        const outputData = outputPixels.data;
        for (let index = 0; index < sourceCanvas.width * sourceCanvas.height; index += 1) {
          const personConfidence = 1 - resizedMaskPixels[index * 4] / 255;
          const normalized = Math.max(0, Math.min(1, (personConfidence - 0.15) / 0.7));
          outputData[index * 4 + 3] = Math.round(normalized * normalized * (3 - 2 * normalized) * 255);
        }
        outputContext.putImageData(outputPixels, 0, 0);
        return outputCanvas;
      } catch (error) {
        clearTemporaryCanvas(outputCanvas);
        throw error;
      } finally {
        clearTemporaryCanvas(maskCanvas);
        clearTemporaryCanvas(resizedMaskCanvas);
      }
    }

    function waitForNextPaint(){
      return new Promise(resolve => requestAnimationFrame(() => resolve()));
    }

    async function processPortrait(sourceCanvas){
      if (!sourceCanvas?.width || !sourceCanvas?.height) return;
      if (portraitProcessingActive) {
        if (sourceCanvas !== retrySourceCanvas) clearTemporaryCanvas(sourceCanvas);
        return;
      }

      const generation = ++portraitGeneration;
      portraitProcessingActive = true;
      replaceRetrySource(sourceCanvas);
      let result = null;
      let segmentedCanvas = null;

      try {
        setPhotoProcessingState("preparing");
        const segmenter = await loadPortraitSegmenter();
        if (generation !== portraitGeneration || portraitProcessingDestroyed) return;

        setPhotoProcessingState("processing");
        await waitForNextPaint();
        if (generation !== portraitGeneration || portraitProcessingDestroyed) return;

        result = segmenter.segment(sourceCanvas);
        if (!result.confidenceMasks?.length) {
          throw new Error("MediaPipe returned no confidence masks.");
        }

        segmentedCanvas = applyMediaPipeAlpha(sourceCanvas, result.confidenceMasks[0]);
        if (generation !== portraitGeneration || portraitProcessingDestroyed) return;

        setFaceFromCanvas(segmentedCanvas);
        if (retrySourceCanvas === sourceCanvas) retrySourceCanvas = null;
        clearTemporaryCanvas(sourceCanvas);
        showStep(adjustmentStep);
        canvas.style.display = "block";
        preloadSelectedAssets(currentBorder, () => renderAll());
        setPhotoProcessingState("idle");
      } catch (error) {
        console.error("❌ Portrait processing error:", error);
        if (generation === portraitGeneration && !portraitProcessingDestroyed) {
          showStep(photoSourceStep);
          canvas.style.display = "none";
          setPhotoProcessingState("error");
        }
      } finally {
        try {
          result?.close();
        } catch (error) {
          console.warn("MediaPipe result cleanup failed:", error);
        }
        clearTemporaryCanvas(segmentedCanvas);
        if (generation === portraitGeneration) portraitProcessingActive = false;
      }
    }

    function teardownPortraitProcessing(){
      if (portraitProcessingDestroyed) return;
      portraitProcessingDestroyed = true;
      portraitGeneration += 1;
      resetCameraUi();
      clearTemporaryCanvas(retrySourceCanvas);
      retrySourceCanvas = null;
      clearTemporaryCanvas(faceBuffer);
      portraitSegmenter?.close();
      portraitSegmenter = null;
      portraitSegmenterPromise = null;
      invalidateExportCache();
      window.wuCardInitialized = false;
    }

    // ======= Camera flow =======
    function stopStream(){
      const s = videoEl?.srcObject;
      if (s) s.getTracks().forEach(t => t.stop());
      videoEl.srcObject = null;
    }

    function resetCameraUi(){
      stopStream();
      videoEl.style.display = "none";
      captureBtn.style.display = "none";
      takeBtn.style.display = "flex";
      if (cameraWrap) cameraWrap.style.display = "none";
    }

    window.addEventListener("beforeunload", teardownPortraitProcessing, { once: true });
    document.addEventListener("shopify:section:unload", event => {
      const app = document.getElementById("wu-card-app");
      if (app && event.target?.contains(app)) teardownPortraitProcessing();
    });

    retryProcessingBtn?.addEventListener("click", () => {
      if (retrySourceCanvas) processPortrait(retrySourceCanvas);
    });

    document.querySelectorAll("input[name='artwork']").forEach(radio => {
      radio.addEventListener("change", event => {
        selectCard(event.target.value, hasFace);
      });
    });

    continueToPhotoBtn?.addEventListener("click", () => {
      if (!hasValidSelectedCard()) {
        syncArtworkSelection();
        return;
      }

      showStep(photoSourceStep);
      preloadSelectedAssets(currentBorder);
      loadPortraitSegmenter().catch(error => {
        console.warn("MediaPipe preload did not complete:", error);
      });
    });

    backToArtworkBtn?.addEventListener("click", () => {
      resetCameraUi();
      mountArtworkControl(artworkSelectionSlot, "ARTWORK");
      showStep(selectionStep);
    });

    backToPhotoBtn?.addEventListener("click", () => {
      resetCameraUi();
      showStep(photoSourceStep);
    });

    takeBtn?.addEventListener("click", async () => {
      if (!hasValidSelectedCard()) {
        mountArtworkControl(artworkSelectionSlot, "ARTWORK");
        showStep(selectionStep);
        return;
      }

      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        if (portraitProcessingDestroyed) {
          stream.getTracks().forEach(track => track.stop());
          return;
        }
        videoEl.srcObject = stream;

        if (videoEl.readyState < 2) {
          await new Promise(res => videoEl.addEventListener('loadedmetadata', res, { once: true }));
        }

        if (cameraWrap) cameraWrap.style.display = "block";
        videoEl.style.display = "block";
        captureBtn.style.display = "inline-block";
        takeBtn.style.display = "none";
      } catch (err) {
        console.error("❌ camera error:", err);
        alert("Unable to access your camera.");
      }
    });

    // ======= Camera capture flow =======
    captureBtn?.addEventListener("click", async () => {
      if (!hasValidSelectedCard()) {
        resetCameraUi();
        mountArtworkControl(artworkSelectionSlot, "ARTWORK");
        showStep(selectionStep);
        return;
      }
      if (!videoEl.videoWidth || !videoEl.videoHeight) return;

      try {
        const boundedSource = createBoundedPortraitSource(videoEl, true);
        resetCameraUi();
        await processPortrait(boundedSource);
      } catch (error) {
        console.error("❌ Camera capture error:", error);
        resetCameraUi();
        showStep(photoSourceStep);
        canvas.style.display = "none";
        setPhotoProcessingState("error");
      }
    });

    // ======= Upload flow (debounced click kept) =======
    let isUploading = false;
    uploadBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (!hasValidSelectedCard()) {
        mountArtworkControl(artworkSelectionSlot, "ARTWORK");
        showStep(selectionStep);
        return;
      }
      if (isUploading) return;

      if (uploadInput) {
        uploadInput.value = '';
        setTimeout(() => {
          isUploading = true;
          uploadInput.click();
          setTimeout(() => { isUploading = false; }, 500);
        }, 10);
      }
    });

    uploadInput?.addEventListener("change", async e => {
      const file = e.target.files?.[0];
      if (!file) return;
      e.stopPropagation();
      if (!hasValidSelectedCard()) {
        uploadInput.value = '';
        mountArtworkControl(artworkSelectionSlot, "ARTWORK");
        showStep(selectionStep);
        return;
      }

      let imageUrl = "";
      const raw = new Image();
      try {
        imageUrl = URL.createObjectURL(file);
        await new Promise((resolve, reject) => {
          raw.onload = resolve;
          raw.onerror = reject;
          raw.src = imageUrl;
        });
        const boundedSource = createBoundedPortraitSource(raw);
        await processPortrait(boundedSource);
      } catch (error) {
        console.error("❌ Upload processing error:", error);
        showStep(photoSourceStep);
        canvas.style.display = "none";
        setPhotoProcessingState("error");
      } finally {
        if (imageUrl) URL.revokeObjectURL(imageUrl);
        raw.src = "";
        uploadInput.value = '';
      }
    });

    // ======= Pointer helpers (robust against CSS scaling) =======
    function getLocalPos(e){
      const rect = canvas.getBoundingClientRect();
      const xCss = (e.clientX ?? (e.touches?.[0]?.clientX ?? 0)) - rect.left;
      const yCss = (e.clientY ?? (e.touches?.[0]?.clientY ?? 0)) - rect.top;
      // Map CSS pixels → canvas pixels
      const x = xCss * (canvas.width / rect.width);
      const y = yCss * (canvas.height / rect.height);
      return { x, y };
    }

    // ======= Pan / Zoom (clamped + RAF + lock during load) =======
    canvas.addEventListener("pointerdown", e => {
      if (uiLocked) return;
      canvas.setPointerCapture(e.pointerId);
      const { x, y } = getLocalPos(e);
      dragging = true;
      startX = x - offsetX;
      startY = y - offsetY;
    });

    canvas.addEventListener("pointermove", e => {
      if (uiLocked || !dragging) return;
      const { x, y } = getLocalPos(e);
      offsetX = x - startX;
      offsetY = y - startY;
      scheduleRender();
    });

    window.addEventListener("pointerup", () => { dragging = false; });
    canvas.addEventListener("pointerleave", () => { dragging = false; });

    document.getElementById("zoom-in")?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (uiLocked) return;
      const newScale = Math.min(maxScale, scale * 1.1);
      const k = newScale / scale;
      const cx = CANVAS_W/2, cy = CANVAS_H/2;
      offsetX = cx - (cx - offsetX) * k;
      offsetY = cy - (cy - offsetY) * k;
      scale = newScale;
      scheduleRender();
    });

    document.getElementById("zoom-out")?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (uiLocked) return;
      const newScale = Math.max(minScale, scale / 1.1);
      const k = newScale / scale;
      const cx = CANVAS_W/2, cy = CANVAS_H/2;
      offsetX = cx - (cx - offsetX) * k;
      offsetY = cy - (cy - offsetY) * k;
      scale = newScale;
      scheduleRender();
    });

    canvas.addEventListener("wheel", (e) => {
      if (uiLocked) return;
      e.preventDefault();
      const { x: mx, y: my } = getLocalPos(e);
      const factor = e.deltaY < 0 ? 1.08 : 0.92;
      const newScale = Math.max(minScale, Math.min(maxScale, scale * factor));
      const k = newScale / scale;

      offsetX = mx - (mx - offsetX) * k;
      offsetY = my - (my - offsetY) * k;

      scale = newScale;
      scheduleRender();
    }, { passive:false });

    // ======= Continue to customization =======
    continueToCustomizeBtn?.addEventListener("click", () => {
      const preview = customizationStep.querySelector(".preview");
      if (preview && !preview.contains(canvas)) preview.appendChild(canvas);

      mountArtworkControl(artworkCustomizeOptions, "ARTWORK");
      setArtworkDisclosureExpanded(false);
      showStep(customizationStep);
      canvas.style.display = "block";

      // CRITICAL FIX: Only render if assets are ready
      if (assetsReady) {
        renderAll();
      } else {
        console.log("⏳ Waiting for assets before rendering in customization");
      }
    });

    document.querySelectorAll("input[name='border']").forEach(radio => {
      radio.addEventListener("change", event => {
        currentBorder = event.target.value;
        preloadSelectedAssets(currentBorder, () => renderAll());
      });
    });

    document.querySelectorAll("input[name='name-color']").forEach(radio => {
      radio.addEventListener("change", () => renderAll());
    });

    // ======= Complete / Save / Share / Start Over =======
    syncExportActions();

    completeBtn?.addEventListener("click", () => {
      showStep(finalStep);
      setExportStatus("Preparing your Wu-Card…");
      runExportAction(async () => {
        try {
          await prepareExport();
          setExportStatus(navigator.share ? "" : "Sharing isn’t available in this browser. You can still save the image.");
        } catch (error) {
          console.error("PNG preparation failed:", error);
          setExportStatus("We couldn’t prepare the image. Please try Save Image again.");
        }
      });
    });

    saveButton?.addEventListener("click", () => {
      runExportAction(async () => {
        setExportStatus("Preparing your Wu-Card…");
        try {
          const output = await prepareExport();
          downloadExport(output);
          setExportStatus("Your Wu-Card is ready to save.");
        } catch (error) {
          console.error("PNG save failed:", error);
          setExportStatus("We couldn’t prepare the image. Please try again.");
        }
      });
    });

    shareButton?.addEventListener("click", () => {
      runExportAction(async () => {
        setExportStatus("Preparing sharing…");
        try {
          const output = await prepareExport();
          if (supportsFileShare(output)) {
            await navigator.share({
              title: "My Official Wu-Card",
              text: "I just generated my official Wu-Card. Make yours:",
              url: window.location.href,
              files: [output.file],
            });
          } else if (navigator.share) {
            await navigator.share({
              title: "My Official Wu-Card",
              text: "I just generated my official Wu-Card. Make yours:",
              url: window.location.href,
            });
          } else {
            setExportStatus("Sharing isn’t available in this browser. You can still save the image.");
            return;
          }
          setExportStatus("");
        } catch (error) {
          if (error?.name === "AbortError") {
            setExportStatus("");
            return;
          }
          console.error("Sharing failed:", error);
          setExportStatus("We couldn’t open sharing. You can still save the image.");
        }
      });
    });

    startOverBtn?.addEventListener("click", () => {
      stopStream();
      invalidateExportCache();
      selectedCardKey = null;
      sessionStorage.removeItem("selectedCardKey");
      syncArtworkSelection();
      window.location.reload();
    });
  }

  // Only init once, even if DOMContentLoaded fires multiple times
  let initialized = false;
  function runInit() {
    if (initialized) return;
    initialized = true;
    init();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit, { once: true });
  } else {
    runInit();
  }
})();
